import { render } from "./CustomCategoryAddItem.vue?vue&type=template&id=4ec82042&scoped=true&ts=true"
import script from "./CustomCategoryAddItem.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryAddItem.vue?vue&type=script&lang=ts"

import "./CustomCategoryAddItem.vue?vue&type=style&index=0&id=4ec82042&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec82042"]])

export default __exports__